import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PayPage from "./pages/PayPage";
import StatusPage from "./pages/StatusPage";
import MITPage from "./pages/MITPage";
import "./App.css";
import CardPage from "./pages/CardsPage";
import AcceptanceLogicPage from "./pages/AcceptanceLogicPage";
import SideMenu from './components/SideMenu';
import LeadAndConnectPage from "./pages/LeadAndConnectPage";

function App() {
  return (
    <Router>
      <div style={{ display: 'flex' }}>
        <SideMenu />
        <div style={{  width: "calc(100% - 300px)"}}>
          <Routes>
            <Route path="/" element={<PayPage />} />
            <Route path="/payment-status" element={<StatusPage />} />
            <Route path="/mit" element={<MITPage />} />
            <Route path="/cards" element={<CardPage />} />
            <Route path="/acceptance-logic-page" element={<AcceptanceLogicPage />} />
            <Route path="/lead-and-connect" element={<LeadAndConnectPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
